import { actions } from "./action-list";

export function setAllOperatorsPassRevenue(value) {
  return {
    type: actions.FETCH_ALL_OPERATOR_PASS_REVENUE,
    value,
  };
}

export function clearOperatorPassRevenueList(value) {
  return {
    type: actions.CLEAR_OPERATOR_PASS_REVENUE,
    value,
  };
}

export function operatorPassRevenueCreated(value) {
  return {
    type: actions.CREATE_OPERATOR_PASS_REVENUE,
    value,
  };
}

export function getPassRevenueCities(value) {
  return {
    type: actions.FETCH_PASS_REVENUE_CITIES,
    value,
  };
}

export function passRevenueUploadSheetFailure(value) {
  return {
    type: actions.PASS_REVENUE_UPLOAD_FAILURE,
    value,
  };
}
